import { moduleQueries } from '../../../modules';
import { pageExperienceQuery, pageQuery, socialQuery, workQuery } from '../queries';

/*

Sample CraftQL Query

{
  entries(slug: "press") {
    ...on Pages {
      id
      slug
      modules {
        ...on ModulesHeroCollaborators {
        	headline
        }
        ...on ModulesTextButton {
          assetLinkedButton {
            ...on AssetLinkedButtonItem {
              asset {
                id
                filename
              }
            }
          }
        }
      }
    }
  }
}

*/

class QueryController {

	globals() {
		return `{
			globals {
				globalLinks {
					links {
						...on LinksItem {
							itemTitle
							itemUrl
						}
					}
				}
			}
			sitemap: entries {
				...on Pages {
					${pageQuery}
				}
				...on Interviews {
					${pageQuery}
					${socialQuery}
					${workQuery}
					paragraph {
						content
					}
					experiences {
						slug
						enabled
					}
				}
				...on Experiences {
					${pageExperienceQuery}
				}
			}
		}`;
	}

	page(type, slug) {
		let moduleQuery = '';

		for (const id in moduleQueries) {
			moduleQuery += `...on ${id} {
				${moduleQueries[id].query}
				__typename
			}`;
		}

		return `{
			entriesConnection(section: ${type}, slug: "${slug}") {
				edges {
					node {
						...on Pages {
							${pageQuery}
							modules {
								${moduleQuery}
							}
						}
						...on Interviews {
							${pageQuery}
							${socialQuery}
							${workQuery}
							experiences {
								...on Experiences {
									${pageExperienceQuery}
								}
							}
							modules {
								${moduleQuery}
							}
							paragraph {
								content
							}
							siblings {
								title
								id
								url
								uri
								...on Interviews {
									teasers {
									  ...on TeasersItem {
									    teaserPortrait {
									      url(transform:coverImage)
									    }
									  }
									}
								}
							}
						}
						...on Experiences {
							${pageExperienceQuery}
							modules {
								${moduleQuery}
							}
							siblings {
								title
								id
								url
								uri
								...on Experiences {
									${pageExperienceQuery}
								}
							}
						}
					}
					relatedEntries (limit: -1) {
						edges {
							node {
								...on Interviews {
									${pageQuery}
									${socialQuery}
									${workQuery}
								}
							}
						}
					}
				}
			}
		}`;
	}

}

export default new QueryController();
